import React, {useEffect, useState} from 'react';
import { MapView, LocationSearch } from '@aws-amplify/ui-react-geo';

import '@aws-amplify/ui-react-geo/styles.css';

import { useMap } from 'react-map-gl';
import {Button, useTheme} from '@aws-amplify/ui-react';

import { useSession } from './SessionContext';
import { addTransparency } from './utils/addTransparency';

function Map() {
    const { tokens } = useTheme();
    const { location, fetchLocation } = useSession();

    const [searchToggle, setSearchToggle] = useState(true);

    function calculateZoomLevel(accuracy) {
        if (accuracy) {
            if (accuracy <= 8) return 18; // Very high accuracy
            if (accuracy <= 16) return 17; // High accuracy
            if (accuracy <= 32) return 16; // Good accuracy
            if (accuracy <= 64) return 15; // Moderate accuracy
            if (accuracy <= 128) return 14; // Low accuracy
            return 13; // Very low accuracy
        }
        else return 12; // No accuracy
    }

    useEffect(() => {
        const banner = document.getElementsByClassName('Banner')[0];
        if (banner) {
            banner.style.backgroundColor = addTransparency(tokens.colors.font.secondary.value, 0.5);
        }

        const searchInput = document.getElementsByClassName('maplibregl-ctrl-geocoder--input')[0];
        if (searchInput) {
            searchInput.style.display = searchToggle ? 'inline' : 'none';
        }

        if (!location) {
            fetchLocation();
        }

        const toggleSearchInput = () => {
            setSearchToggle(prevToggle => {
                const newToggle = !prevToggle;
                if (searchInput) {
                    searchInput.style.display = newToggle ? 'inline' : 'none';
                }
                return newToggle;
            });
        };

        const searchIcon = document.getElementsByClassName('maplibregl-ctrl-geocoder--icon-search')[0];
        if (searchIcon) {
            searchIcon.addEventListener('click', toggleSearchInput);
        }

        // Cleanup function to remove the event listener
        return () => {
            if (searchIcon) {
                searchIcon.removeEventListener('click', toggleSearchInput);
            }
        };
    }, [tokens, location, fetchLocation, searchToggle]);

    function FlyToButton() {
        const { current: map } = useMap();

        const flyToLocation = async () => {
            if (location) {
                console.info(`Centering to lat,lon ${location.latitude},${location.longitude} with accuracy ${location.accuracy}`);
                map.flyTo({center: [location.longitude, location.latitude], zoom: calculateZoomLevel(location.accuracy), speed: 0.3});
            }
            else {
                console.error('No location available');
            }
        };

        return <Button onClick={flyToLocation} style={{
            fontSize: `${tokens.fontSizes.xl}`,
            lineHeight: `${tokens.fontSizes.small}`,
            padding: `${tokens.fontSizes.xxs} ${tokens.fontSizes.xxs} ${tokens.fontSizes.medium} ${tokens.fontSizes.xxs}`,
            backgroundColor: `${tokens.colors.brand.primary[80].value}`,
            color: 'white'
        }}>⌖</Button>;
    }

    return (
    <MapView
        initialViewState={{
            latitude: location? location.latitude : 0,
            longitude: location? location.longitude : 0,
            zoom: location? calculateZoomLevel(location.accuracy) : 1
        }}
        style={{ width: '100%', height: '100vh' }}
    >
      <LocationSearch position="top-left" />
      {location? (
      <div style={{ position: 'absolute', top: '60%', right: '8px', zIndex: '+1' }}>
        <FlyToButton />
      </div>
      ):(
          <></>
      )}
    </MapView>
    );
}

export default Map;
